import { render, staticRenderFns } from "./crList.vue?vue&type=template&id=5633d64c&"
import script from "./crList.vue?vue&type=script&lang=js&"
export * from "./crList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports